'use client'
import {
   BehanceIcon,
   ClutchIcon,
   FlagIcon,
   FlagIconIndia,
   FooterLogoIcon,
   GitHubIcon,
   InstaIcon,
   LinkedInIcon,
   LocationIcon,
   LolliPopIcon,
   MailIcon,
   TelePhoneIcon,
   UpWorkIcon,
} from '@/svgs'
import ContactMailIcon from '@/svgs/ContactMailIcon'
import React, { useEffect, useRef, useState } from 'react'
import Script from 'next/script'
import Link from 'next/link'

export default function Footer() {
   const [isVisible, setIsVisible] = useState(false)

   useEffect(() => {
      // Move DOM queries inside useEffect to ensure they run client-side
      if (typeof window !== 'undefined') {
         const accordionTriggers =
            document.querySelectorAll('.accordion-trigger')
         const footerColUls = document.querySelectorAll('.footer_col ul')

         const resetAccordion = () => {
            if (window.innerWidth > 991) {
               accordionTriggers.forEach((trigger) => {
                  trigger.classList.remove('active')
               })
               footerColUls.forEach((ul) => {
                  ul.style.height = 'auto'
                  ul.style.opacity = '1'
                  ul.classList.remove('active')
               })
            } else {
               footerColUls.forEach((ul) => {
                  ul.style.height = '0'
                  ul.style.opacity = '0'
                  ul.classList.remove('active')
               })
            }
         }

         const handleClick = function () {
            if (window.innerWidth <= 991) {
               const content = this.nextElementSibling
               const isActive = this.classList.contains('active')

               // Close all
               accordionTriggers.forEach((t) => {
                  t.classList.remove('active')
                  const ul = t.nextElementSibling
                  ul.style.height = '0'
                  ul.style.opacity = '0'
                  ul.classList.remove('active')
               })

               // Open clicked
               if (!isActive) {
                  this.classList.add('active')
                  content.classList.add('active')
                  content.style.height = content.scrollHeight + 'px'
                  content.style.opacity = '1'
               }
            }
         }

         // Add event listeners
         accordionTriggers.forEach((trigger) =>
            trigger.addEventListener('click', handleClick)
         )
         window.addEventListener('resize', resetAccordion)
         resetAccordion()

         // Cleanup
         return () => {
            accordionTriggers.forEach((trigger) =>
               trigger.removeEventListener('click', handleClick)
            )
            window.removeEventListener('resize', resetAccordion)
         }
      }
   }, [])

   // scroll to top
   useEffect(() => {
      const toggleVisibility = () => {
         if (window.scrollY > 300) {
            setIsVisible(true)
         } else {
            setIsVisible(false)
         }
      }

      window.addEventListener('scroll', toggleVisibility)
      return () => window.removeEventListener('scroll', toggleVisibility)
   }, [])

   const scrollToTop = () => {
      window.scrollTo({
         top: 0,
         behavior: 'smooth',
      })
   }

   return (
      <>
         <Script
            src={`https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`}
            strategy="beforeInteractive"
         />

         <footer className="custom_footer section_primary_bg">
            <div className="container_main">
               <div className="footer_content">
                  <div className="footer_left">
                     <div className="footer_logo">
                        <FooterLogoIcon />
                     </div>
                     <p className="footer_desc">
                        Since we kicked off in 2013, we've grown fast into a
                        go-to IT crew that's known worldwide. We help all kinds
                        of businesses level up with sharp software, solid mobile
                        apps, smart AI/ML tools, and top-picture IT services.
                        We've worked with tons of industries, so we know how to
                        tweak tech to fit just right—boosting what you do and
                        pushing you into the digital future. It's practical,
                        it's powerful and it works!
                     </p>
                     <div className="social_links">
                        <a
                           href="https://www.upwork.com/agencies/benzatineinfotech/"
                           target="_blank"
                           className="social_link"
                        >
                           <UpWorkIcon />
                        </a>
                        <a
                           href="https://clutch.co/profile/benzatine-infotech"
                           target="_blank"
                           className="social_link"
                        >
                           <ClutchIcon />
                        </a>
                        <a
                           href="https://github.com/bpvadukia"
                           target="_blank"
                           className="social_link"
                        >
                           <GitHubIcon />
                        </a>
                        <a
                           href="https://www.linkedin.com/company/benzatine-infotech"
                           target="_blank"
                           className="social_link"
                        >
                           <LinkedInIcon />
                        </a>
                        <a
                           href="https://www.instagram.com/benzatine.infotech/"
                           target="_blank"
                           className="social_link"
                        >
                           <InstaIcon />
                        </a>
                        <a
                           href="mailto:hr@benzatine.com"
                           className="social_link"
                        >
                           <MailIcon />
                        </a>
                        <a
                           href="https://www.behance.net/benzatine-infotech"
                           target="_blank"
                           className="social_link"
                        >
                           <BehanceIcon />
                        </a>
                     </div>
                     <div className="footer_tagline">
                        <span>
                           <LolliPopIcon />
                        </span>
                        <span>Born In India, Built For The World</span>
                     </div>
                  </div>

                  <div className="footer_links">
                     <div className="footer_col">
                        <h3 className="accordion-trigger">
                           Our Services
                           <span className="accordion-icon">+</span>
                        </h3>
                        <ul className="accordion-content">
                           <li>
                              <Link href="/services/ai-ml-development-company">
                                 AI & ML Development
                              </Link>
                           </li>
                           <li>
                              <Link href="/services/eommerce-development-company">
                                 Ecommerce Development
                              </Link>
                           </li>
                           <li>
                              <Link href="/services/web-application-development-company">
                                 Web Application Development
                              </Link>
                           </li>
                           <li>
                              <Link href="/services/custom-software-development-company">
                                 Custom Software Development
                              </Link>
                           </li>
                           <li>
                              <Link href="/services/progressive-web-app-development-company">
                                 Progressive Web App Development
                              </Link>
                           </li>
                           <li>
                              <Link href="/services/mobile-application-development-company">
                                 Mobile App Development
                              </Link>
                           </li>
                           <li>
                              <Link href="/services/blockchain-development-company">
                                 Blockchain Development
                              </Link>
                           </li>
                           <li>
                              <Link href="/services/testing-qa-services-company">
                                 Testing and QA Services
                              </Link>
                           </li>
                           <li>
                              <Link href="/services/web-design-services-company">
                                 Web design Services
                              </Link>
                           </li>
                        </ul>
                     </div>
                     <div className="footer_col">
                        <h3 className="accordion-trigger">
                           Technologies
                           <span className="accordion-icon">+</span>
                        </h3>
                        <ul className="accordion-content">
                           <li>
                              <Link href="/technologies/ai-ml/ai-chatbot-development-services">
                                 AI/ML
                              </Link>
                           </li>
                           <li>
                              <Link href="/technologies/backend/aspdotnet-development-company">
                                 Backend
                              </Link>
                           </li>
                           <li>
                              <Link href="/technologies/blockchain/ethereum-development-company">
                                 Blockchain
                              </Link>
                           </li>
                           <li>
                              <Link href="/technologies/design-prototype">
                                 Design & Prototype
                              </Link>
                           </li>
                           <li>
                              <Link href="/technologies/ecommerce/bigcommerce-development-company">
                                 Ecommerce
                              </Link>
                           </li>
                           <li>
                              <Link href="/technologies/frontend/angular-development-company">
                                 Frontend
                              </Link>
                           </li>
                           <li>
                              <Link href="/technologies/mobile/android-application-development-company">
                                 Mobile
                              </Link>
                           </li>
                           <li>
                              <Link href="/technologies/project-management">
                                 Project Management
                              </Link>
                           </li>
                           <li>
                              <Link href="/technologies/qa-testing/automated-testing-services">
                                 QA & Testing
                              </Link>
                           </li>
                        </ul>
                     </div>
                     <div className="footer_col">
                        <h3 className="accordion-trigger">
                           Our Industries
                           <span className="accordion-icon">+</span>
                        </h3>
                        <ul className="accordion-content">
                           <li>
                              <Link href="/industries/fintech-software-development-solutions">
                                 Fintech
                              </Link>
                           </li>
                           <li>
                              <Link href="/industries/e-commerce-software-development-solutions">
                                 Ecommerce
                              </Link>
                           </li>
                           <li>
                              <Link href="/industries/travel-tourism-software-development-solutions">
                                 Travel & Tourism
                              </Link>
                           </li>
                           <li>
                              <Link href="/industries/restaurant-hospitality-software-solutions">
                                 Restaurants & Hospitality
                              </Link>
                           </li>
                           <li>
                              <Link href="/industries/education-software-development-solutions">
                                 Education
                              </Link>
                           </li>
                           <li>
                              <Link href="/industries/real-estate-software-development-solutions">
                                 Real Estate
                              </Link>
                           </li>
                           <li>
                              <Link href="/industries/health-fitness-software-development-solutions">
                                 Health And Fitness
                              </Link>
                           </li>
                           <li>
                              <Link href="/industries/supply-chain-logistics-software-solutions">
                                 Supply Chain And Logistics
                              </Link>
                           </li>
                           <li>
                              <Link href="/industries/gaming-sports-software-development-solutions">
                                 Gaming & Sports
                              </Link>
                           </li>
                           <li>
                              <Link href="/industries/social-dating-software-development-solutions">
                                 Social And Dating
                              </Link>
                           </li>
                           <li>
                              <Link href="/industries/media-entertainment-software-solutions">
                                 Media & Entertainment
                              </Link>
                           </li>
                           <li>
                              <Link href="/industries/government-public-sector-software-solutions">
                                 Government & Public Sector
                              </Link>
                           </li>
                        </ul>
                     </div>
                     <div className="footer_col">
                        <h3 className="accordion-trigger">
                           Discover Benzatine
                           <span className="accordion-icon">+</span>
                        </h3>
                        <ul className="accordion-content">
                           <li>
                              <Link href="/discover-benzatine/about-us">
                                 About Our Company
                              </Link>
                           </li>
                           <li>
                              <Link href="/discover-benzatine/our-work-process">
                                 Our Work Process
                              </Link>
                           </li>
                           <li>
                              <Link href="/discover-benzatine/career-overview">
                                 Our Career Overview
                              </Link>
                           </li>
                           <li>
                              <Link href="/discover-benzatine/our-culture">
                                 Our Culture
                              </Link>
                           </li>
                           <li>
                              <Link href="/html-sitemap">HTML Sitemap</Link>
                           </li>
                        </ul>
                        <div className="headquarter headquarter2">
                           <h3 className="mb-2">
                              Headquartered At
                              <LocationIcon />
                           </h3>

                           <FlagIconIndia />
                           <a
                              href="https://maps.app.goo.gl/vhY8JxZBUtXohuv58"
                              target="_blank"
                              rel="noopener noreferrer"
                           >
                              401 to 403, Laxmi Enclave - 1 opp. Gajera School,
                              Katargam, Surat-395004, Gujarat, India.
                           </a>
                           <div className="mt-2">
                              <FlagIcon />
                              <a
                                 href="https://maps.app.goo.gl/AzY572JujfEvdi4u5"
                                 target="_blank"
                              >
                                 23302 BREWERS TAVERN WAY CLARKSBURG MD 20871
                              </a>
                           </div>
                        </div>
                     </div>
                     <div className="footer_col d-lg-none">
                        <h3 className="accordion-trigger">
                           Contact Us
                           <span className="accordion-icon">+</span>
                        </h3>
                        <ul className="accordion-content">
                           <div className="footer_contact">
                              <div className="contact_item d-flex gap-2">
                                 <TelePhoneIcon />
                                 <div className="d-flex flex-column gap-2">
                                    <span>Contact - HR</span>
                                    <a href="tel:+917567583566">
                                       +91 75675 83566
                                    </a>
                                 </div>
                              </div>
                              <div className="contact_item d-flex gap-2">
                                 <TelePhoneIcon />
                                 <div className="d-flex flex-column gap-2">
                                    <span>Contact - Sales</span>
                                    <a href="tel:+919913360998">
                                       +91 99133 60998
                                    </a>
                                 </div>
                              </div>
                              <div className="contact_item d-flex gap-2">
                                 <ContactMailIcon />

                                 <div className="d-flex flex-column gap-2">
                                    <span>Write Us At</span>
                                    <a href="mailto:contact@benzatine.com">
                                       contact@benzatine.com
                                    </a>
                                 </div>
                              </div>
                              <div className="contact_item d-flex gap-2">
                                 <ContactMailIcon />

                                 <div className="d-flex flex-column gap-2">
                                    <span>For career & More</span>
                                    <a href="mailto:hr@benzatine.com">
                                       hr@benzatine.com
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </ul>
                        <div className="headquarter">
                           <h3
                              className=" mb-2 mx-0 mt-0 p-0"
                              style={{ border: '0px' }}
                           >
                              <span> Headquartered At</span>
                              <LocationIcon />
                           </h3>
                           <h3 className=" d-flex gap-2 align-items-center">
                              {/* <FlagIconIndia /> */}
                              <img
                                 src="/assets/image/indianflg.png"
                                 alt="indian flag"
                                 className="m-0"
                                 style={{
                                    height: '22px',
                                    width: '32px',
                                 }}
                              />
                           </h3>
                           <a
                              href="https://maps.app.goo.gl/vhY8JxZBUtXohuv58"
                              target="_blank"
                              rel="noopener noreferrer"
                           >
                              401 to 403, Laxmi Enclave - 1 opp. Gajera School,
                              Katargam, Surat-395004, Gujarat, India.
                           </a>
                           <h3 className="mb-2 d-flex gap-2 align-items-center pt-0">
                              <FlagIcon />
                           </h3>
                           <a
                              href="https://maps.app.goo.gl/AzY572JujfEvdi4u5"
                              target="_blank"
                           >
                              23302 BREWERS TAVERN WAY CLARKSBURG MD 20871
                           </a>
                        </div>
                     </div>
                  </div>
               </div>

               <div className="footer_contact footer_contact2">
                  <div className="contact_item d-flex gap-2">
                     <TelePhoneIcon />
                     <div className="d-flex flex-column gap-2">
                        <span>Contact - HR</span>
                        <a href="tel:+917567583566">+91 75675 83566</a>
                     </div>
                  </div>
                  <div className="contact_item d-flex gap-2">
                     <TelePhoneIcon />
                     <div className="d-flex flex-column gap-2">
                        <span>Contact - Sales</span>
                        <a href="tel:+919913360998">+91 99133 60998</a>
                     </div>
                  </div>
                  <div className="contact_item d-flex gap-2">
                     <ContactMailIcon />

                     <div className="d-flex flex-column gap-2">
                        <span>Write Us At</span>
                        <a href="mailto:contact@benzatine.com">
                           contact@benzatine.com
                        </a>
                     </div>
                  </div>
                  <div className="contact_item d-flex gap-2">
                     <ContactMailIcon />

                     <div className="d-flex flex-column gap-2">
                        <span>For career & More</span>
                        <a href="mailto:hr@benzatine.com">hr@benzatine.com</a>
                     </div>
                  </div>
               </div>

               <div className="footer_bottom">
                  <p>
                     Copyright © {new Date().getFullYear()} Benzatine Infotech,
                     All Rights Reserved.
                  </p>
                  <div className="footer_legal">
                     <Link href="/privacy-policy">Privacy Policy</Link>
                     <Link href="/privacy-policy#terms-condition">
                        Terms & Conditions
                     </Link>
                  </div>
               </div>
            </div>
         </footer>
         <button
            id="scrollToTopBtn"
            className="scrollbtn"
            onClick={scrollToTop}
            style={{ display: isVisible ? 'inline' : 'none' }}
         >
            ↑
         </button>
      </>
   )
}
